import { v4 as UUid } from 'uuid';
import ID from '@compassdigital/id';

// eslint-disable-next-line import/prefer-default-export
export const generateCdlId = function generateCdlId(service, provider, type) {
  return ID(service, provider, type, UUid().replace(/-/g, ''));
};
